import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'mat-form-field[aiSearch], mat-input-container[aiSearch]'
})
export class AiSearchDirective {

  @HostBinding('class.ai-search-input') true;

}
